const Roles = Object.freeze({
  Admin: 'admin',
});

export default Roles;
